import { render, staticRenderFns } from "./UserSA.vue?vue&type=template&id=79a6b432&"
import script from "./UserSA.vue?vue&type=script&lang=js&"
export * from "./UserSA.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports